<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="1000" persistent scrollable>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="rounded-lg">
          <v-card-title class="pa-3 ml-3 mr-3">
            {{ $t("dashboard.groupconsentdetail") }}<v-spacer></v-spacer>
            <v-btn color="#077893" outlined @click="Fn_Close()">
              {{ $t("consentform.close") }}</v-btn
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap justify-center align-center ml-3 pa-1>
              <v-flex xs12 lg12
                ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                <span v-if="DataConsent.ShowPolicy === true">{{
                  PolicyHeader
                }}</span>
                <a v-else v-on:click="Fn_DetailPolicy">{{ PolicyHeader }} </a>
                <br />
                <b>{{ $t("dashboard.org") }} :</b> {{ BusinessNameTh }}
              </v-flex>
              <v-flex xs12 lg12 pt-5 v-if="DataConsent.ShowPolicy === true">
                <v-card outlined>
                  <v-card-title> รายละเอียดนโยบาย </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center pa-1>
                      <v-flex xs12 lg12 text-left>
                        <div v-html="PolicyDetail"></div>

                        <b>ข้อมูลที่ต้องการขอ </b>
                        <v-chip
                          small
                          style="border: 1px solid"
                          v-for="(item, i) in itemsRequest"
                          :key="i"
                          class="ma-1"
                          label
                          text-color="#077893"
                          color="#ddf7ff"
                        >
                          <b>{{ item }}</b>
                        </v-chip>
                      </v-flex>
                      <v-flex xs11 lg11 v-if="ShowStatus">
                        <v-radio-group
                          v-model="item.Status"
                          row
                          :rules="[(v) => !!v || 'กรุณาเลือก ความยินยอม']"
                        >
                          <v-radio label="ยินยอม" value="approve"></v-radio>
                          <v-divider vertical></v-divider>
                          <v-radio
                            class="ml-5"
                            label="ไม่ยินยอม"
                            value="unapprove"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs10 lg3 v-else-if="!ShowStatus"> </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex
                xs12
                lg12
                pt-5
                pr-5
                v-else
                v-for="(item, index) in Consent"
                :key="index"
              >
                <v-card outlined>
                  <v-card-title>
                    {{ index + 1 }}. {{ item.ConsentHeader }}
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center pa-1>
                      <v-flex xs12 lg12 text-left>
                        <div class="pb-1">
                          <b>รายละเอียดยินยอม</b>
                        </div>
                        <span v-html="item.ConsentDetail"></span>
                        <div class="pb-1">
                          <b>รายละเอียดไม่ยินยอม</b>
                        </div>
                        <span v-html="item.ConsentReject"></span>
                        <br />
                        <b>ข้อมูลที่ต้องการขอ </b>
                        <v-chip
                          small
                          style="border: 1px solid"
                          v-for="(item, i) in itemsRequest"
                          :key="i"
                          class="ma-1"
                          label
                          text-color="#077893"
                          color="#ddf7ff"
                        >
                          <b>{{ item }}</b>
                        </v-chip>
                      </v-flex>
                      <v-flex xs10 lg12 v-if="ShowStatus">
                        <v-radio-group
                          v-model="item.Status"
                          row
                          :rules="[(v) => !!v || 'กรุณาเลือก ความยินยอม']"
                        >
                          <v-radio label="ยินยอม" value="approve"></v-radio>
                          <v-divider vertical></v-divider>
                          <v-radio
                            class="ml-5"
                            label="ไม่ยินยอม"
                            value="unapprove"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs10 lg3 v-else-if="!ShowStatus"> </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-layout
              row
              wrap
              justify-center
              align-center
              pa-5
              v-if="NameBtnSave === 'ยืนยันตัวเลือกของฉัน'"
            >
              <v-flex xs8 sm8 md2 lg2>
                <v-btn
                  color="#077893"
                  :loading="load"
                  block
                  dark
                  @click="Fn_Save()"
                >
                  {{ NameBtnSave }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center align-self-center pb-4 v-else>
              <v-flex xs11 sm10 md4 lg4>
                <v-alert outlined type="success" text>
                  {{ NameBtnSave }}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
    <DialogGroupConsent
      :show="DialogGroup"
      :_header="PolicyHeader"
      :_detail="PolicyDetail"
      @closeDialogDelete="DialogGroup = false"
    />
  </div>
</template>
<script>
import DialogGroupConsent from "@/components/dialog/DialogGroupConsentDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: { DialogGroupConsent, OverlaySearch },
  props: ["show", "item"],
  data: function () {
    return {
      valid: true,
      Consent: [],
      DataConsent: [],
      itemsRequest: [],
      DataConsentStatus: [],
      PolicyHeader: "",
      PolicyName: "",
      PolicyDetail: "",
      BusinessNameTh: "",
      BusinessNameEng: "",
      Status: "",
      ShowStatus: true,
      loadingDownloadData: false,
      DialogGroup: false,
      NameBtnSave: "ยืนยันตัวเลือกของฉัน",
      load: false,
    };
  },
  computed: {
    shower: {
      ...mapGetters(["DataGeneralConsent"]),
      ...mapGetters(["DataGroupConsent"]),
      ...mapGetters(["Business"]),
      _SendId: {
        get() {
          return this.DataGroupConsent.SendId || "-";
        },
      },
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  mounted() {},
  methods: {
    Fn_Close() {
      this.$emit("closeDialog");
    },
    Fn_ClearData() {
      this.Consent = [];
      this.DataConsent = [];
      this.itemsRequest = [];
      this.DataConsentStatus = [];
      this.PolicyHeader = "";
      this.PolicyName = "";
      this.PolicyDetail = "";
      this.BusinessNameTh = "";
      this.BusinessNameEng = "";
      this.Status = "";
      this.load = false;
    },
    async Fn_GetDataEmail() {
      this.Fn_ClearData();
      this.loadingDownloadData = true;

      var payload = {
        EmailId: this.item.EmailId,
        Type: this.item.Type,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/CheckConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.show = true;

          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
            this.Consent = response.data.Message.Consent;
            this.PolicyName = response.data.Message.Name;
            this.PolicyHeader = response.data.Message.PolicyHeader;
            this.PolicyDetail = response.data.Message.PolicyDetail;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.BusinessNameEng = response.data.Message.BusinessNameEng;
            var FixArray = response.data.Message.Tag;
            this.itemsRequest = FixArray.split(",").map((item) => item.trim());
            for (var item of response.data.Message.Consent) {
              this.Status = item.Status;
              if (this.Status === "approve" || this.Status === "unapprove") {
                this.NameBtnSave = "คุณได้บันทึกรายการเรียบร้อยแล้ว";
                this.ShowStatus = false;
              } else {
                this.NameBtnSave = "ยืนยันตัวเลือกของฉัน";
                this.ShowStatus = true;
              }
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") + error.message || error,
            });
          }
        });
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        this.load = true;
        if (this.DataConsent.ShowPolicy == true) {
          for (var i = 0; i < this.Consent.length; i++) {
            var x = {
              ConsentId: this.Consent[i].ConsentId,
              Status: this.item.Status,
            };
            this.DataConsentStatus.push(x);
          }
        } else {
          for (var i = 0; i < this.Consent.length; i++) {
            var x = {
              ConsentId: this.Consent[i].ConsentId,
              Status: this.Consent[i].Status,
            };
            this.DataConsentStatus.push(x);
          }
        }
        var payload = {
          BusinessId: this.DataConsent.BusinessId,
          EmailId: this.item.EmailId,
          ConsentGroupId: this.DataConsent.ConsentGroupId,
          Consent: this.DataConsentStatus,
          PolicyId: this.DataConsent.PolicyId,
          AccountId: this.DataConsent.AccountId,
          Email: this.DataConsent.Email,
          Name: this.DataConsent.Name,
          Tel: this.DataConsent.Tel,
        };
        var Headers = {
          AccountId: this.$cookies.get("ChatAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };

        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "email/Confirm",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDownloadData = false;
            this.load = false;

            if (response.data.Status === "OK") {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("alert.confirm"),
              });
              this.NameBtnSave = this.$i18n.t("alert.list");
              this.ShowStatus = false;
              this.$emit("closeDialog");
              this.$emit("reData");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            this.load = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_DetailPolicy() {
      this.DialogGroup = true;
    },
    Fn_Cancle() {
      // window.close()
      this.$refs.formData.reset();
      this.load = false;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.Fn_GetDataEmail();
      }
    },
  },
};
</script>
